@if (_active2) {
  <kendo-window
    [class.editFieldsModeClass]="_pageState == 4"
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()"
    #mainWindow>
    <!-- Form-->
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row special_row_margin">
        <div [class.category-border-section-chart]="_pageState != 2 && _pageState != 4 && _SIQActive"
          class="col-6 category-border-section special_col_padding"
          [class.col-12]="_pageState == 2 || _pageState == 4 || _currentUser.isEnterprise">
          <div [ngClass]="{'border_sections margin-top-4 bordered-With-charts': !_currentUser.isEnterprise,'border_sections margin-top-4':_currentUser.isEnterprise}">
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Category
                  @if (canAccess(_permissionScope, 'update')) {
                    <span (click)="_edit()"
                      [class.ViewModeVisibleElement]="_pageState == 1" class="action-button action-button-viewMode">
                      <div class="action-button-icon">
                        <img src="/assets/menu/enterprise/edit-action-icon-grid.svg" />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  }
                </h2>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    @if (canAccess(_permissionScope, 'update') && this._currentUser.appRole.id!=3 && this._currentUser.appRole.id!=4) {
                      <li
                        (click)="_onEditForms()" [class.ViewModelHiddenElement]="_pageState != 2">
                        Edit Forms
                      </li>
                    }
                    @if ( this._currentUser.appRole.id!=3 && this._currentUser.appRole.id!=4 ) {
                      <li
                        class="wikiButton"
                        (click)="_onEditFields()"
                        [class.ViewModeHiddenElement]="_pageState != 2">
                        Edit Fields
                      </li>
                    }
                    <li class="wikiButton" (click)="_returnAdNew()" [class.ViewModeHiddenElement]="_pageState != 4">
                      Close Edit Fields
                    </li>
                    <!-- <li [class.ViewModeHiddenElement]="_pageState == 1">Edit Forms</li> -->
                    <!-- <li class="wikiButton">Wiki</li> -->
                    @if (_pageState == 2) {
                      <li
                        class="wikiButton"
                        class="wikiButton"
                        [class.disabled]="_deactivatedFieldsGridData?.length == 0"
                        (click)="_viewInactiveFields();_deactivatedFieldsForm=true">
                        View Inactive Fields
                      </li>
                    }
                    @if (_pageState == 2) {
                      <li
                        class="wikiButton"
                        [class.disabled]="_deactivatedFormTabsGridData?.length == 0"
                        (click)="_viewInactiveFormTabs();_deactivatedFormTabsForm=true"
                        >
                        View Inactive Form Tabs
                      </li>
                    }
                  </ul>
                  @if (_pageState != 1) {
                    <div>
                      <button kendoButton class="steps_buttons_class" (click)="_onCancel()">
                        <img class="backimage"
                          [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                          <span>close</span>
                        </button>
                        @if (canAccess(_permissionScope, 'create')) {
                          <button
                            kendoButton
                            class="steps_buttons_class"
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndCopy')">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save & Copy</span>
                          </button>
                        }
                        @if (canAccess(_permissionScope, 'create')) {
                          <button
                            kendoButton class="steps_buttons_class"
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndNew')">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save & New</span>
                          </button>
                        }
                        <button kendoButton class="steps_buttons_class" [disabled]="_pageState == 4 ? true : false" (click)="_onSave('saveAndClose')">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & Close</span>
                        </button>
                        <button kendoButton class="steps_buttons_class" [disabled]="_pageState == 4 ? true : false" (click)="_onSave('save')">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save</span>
                        </button>
                      </div>
                    }
                  </div>
                </div>
                <div class="col-12">
                  <div class="formsMenuSeparator"></div>
                </div>
              </div>
              <div class="row row_padding">
                <fieldset class="col-12" [class.col-6-imp]="_pageState == 2 || _pageState == 4 || _currentUser.isEnterprise">
                  <div KendoToolTip
                    class="form-group from_but_container special_style_formgroup margin-top-10">
                    <label for="code" class="control-label">
                      {{getLabel("LBL_CatCode")?.currentText}}
                    </label>
                    <input #kendo_BarcodeGen_Category_Number
                      (focus)="_removeTabActiveAndRemoveSkip()"
                      type="text"
                      [class.ViewModeDisabledControl]="_pageState == 1"
                      class="k-textbox writebox min-width-0 newFormControlWidth"
                      [placeholder]="'Code'"
                      (keyup.enter)="_barcodeSubmited()"
                      (keydown.Tab)="_barcodeSubmited()"
                      (focusout)="_barcodeSubmited()"
                      formControlName="code"
                      entityName="categories"
                      [formControl]="_categoryCode"
                      required
                      [attr.disabled]="getAuthByLabel('LBL_CatCode')?.canEdit ? null : 'disabled'" />
                      <a class="cursor-pointer"
                        [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4" (click)="_generateBarcodeClick()">
                        <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                      </a>
                      <a title="Edit {{getLabel('LBL_CatCode')?.currentText}}"
                        [class.editfieldsIconvisible]="_pageState == 4"
                        class="editFieldsIcon"
                        (click)="_openRenameForm('LBL_CatCode', true)">
                        <img class="searchIcon"
                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                        </a>
                      </div>
                      @if (getAuthByLabel('LBL_CatDesc')?.canView) {
                        <div
                          KendoToolTip class="form-group special_style_formgroup">
                          <label for="description" class="control-label">
                            {{getLabel("LBL_CatDesc")?.currentText}}
                          </label>
                          <input #kendo_Input_Category_Description
                            (focus)="_removeTabActiveAndSkipAdd()"
                            (keyup.enter)="_CatDescSubmited()"
                            (keydown.Tab)="_CatDescSubmited()"
                            (focusout)="_CatDescFocusout()"
                            type="text"
                            class="k-textbox writebox newFormControlWidth"
                            [class.ViewModeDisabledControl]="_pageState == 1"
                            formControlName="description"
                            placeholder=""
                            [attr.disabled]="getAuthByLabel('LBL_CatDesc')?.canEdit ? null : 'disabled'"
                            [attr.required]="getLabel('LBL_CatDesc')?.isRequired ? 'required' : null" />
                            <span class="inputSkipButton" (click)="_skipCategoryDescription()">
                              skip
                              <img [src]="'/assets/menu/'+ _theme +'/yellow-skip-arrow.svg'" />
                            </span>
                            <a title="Edit {{getLabel('LBL_CatDesc')?.currentText}}" [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                              (click)="_openRenameForm('LBL_CatDesc')">
                              <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                            </a>
                          </div>
                        }
                      </fieldset>
                    </div>
                  </div>
                </div>
                @if (_pageState != 2 && _pageState != 4 && !_currentUser.isEnterprise) {
                  <div class="col-6 special_col_padding">
                    <div class="border_sections margin-top-4 bordered-With-charts">
                      @if ((_currentUser && !_currentUser.isEnterprise)) {
                        <div
                          class="col-12 appliance-Sharts-Container">
                          <div class="tabsSection">
                            <ul class="tabsectionList">
                              @if (accessFrom == 'stock') {
                                <li
                                  [class.activetabShart]="_SIQActive"
                                  (click)="_SIQTabClick()"
                                  class="LS">
                                  Stock Item Qty
                                </li>
                              }
                              @if (imageUrl && _showimageTab) {
                                <li
                                  [class.activetabShart]="_imageTabActive"
                                  (click)="_imageTabClick()"
                                  class="LS">
                                  Category image
                                </li>
                              }
                            </ul>
                            @if (_imageTabActive && imageUrl) {
                              <div class="row category-file col-12">
                                <img class="filesChartsImageTab"
                                  [src]="_storagePath + imageUrl"
                                  appImagePopup />
                                </div>
                              }
                            </div>
                            <!-- <div class="clickablelayer" *ngIf="_SIQActive" (click)="_SIQChartClick()"></div> -->
                            @if (_SIQActive && stockItemQuantityChart && stockItemQuantitySecondChart && _receiveGridColumns) {
                              <div
                                class="stock-item-quantity-chart">
                                <div id="chart-line">
                                  <apx-chart (click)="_SIQChartClick($event)"
                                    [series]="stockItemQuantityChart.series"
                                    [chart]="stockItemQuantityChart.chart"
                                    [xaxis]="stockItemQuantityChart.xaxis"
                                    [dataLabels]="stockItemQuantityChart.dataLabels"
                                    [stroke]="stockItemQuantityChart.stroke">
                                  </apx-chart>
                                </div>
                                <div>
                                  <apx-chart [series]="stockItemQuantitySecondChart.series"
                                    [chart]="stockItemQuantitySecondChart.chart"
                                    [xaxis]="stockItemQuantitySecondChart.xaxis">
                                  </apx-chart>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
                <div class="example-wrapper">
                  <div class="row no_row_margin">
                    <div [ngClass]="{'col-8 col-lg-8 col-xl-8': !_currentUser.isEnterprise,'col-12 col-lg-12 col-xl-12':_currentUser.isEnterprise}"
                      class="responsive_style numericboxtab"
                      #kendo_tabstrip_wrapper>
                      <kendo-tabstrip (tabSelect)="_onTabSelect($event)"
                        [tabPosition]="_kendoTabStripPosition">
                        <!-- Accounts Tab -->
                        @if (_currentUser && _currentUser.isEnterprise) {
                          <kendo-tabstrip-tab
                            #accountTab title="Accounts"
                            [selected]="_currentUser && _currentUser.isEnterprise">
                            <ng-template kendoTabContent>
                              <div class="greytabtop menumobilecontainer">
                                <img class="mobiletabIcon" (click)="_mobileMenuToggle()" [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                              </div>
                              <div class="tabcontent tabWizGridInside accountTab" [class.active]="_addClassActive">
                                <asap-account-sites-selection
                                  [class.ViewModeDisabledControl]="_pageState == 1"
                                  [disabled]="_pageState == 1"
                                  [selectedAccounts]="_selectedAccounts"
                                  [enableSiteSelection]="false"
                                  [resolver]="_getAccounts"
                                  (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)">
                                </asap-account-sites-selection>
                              </div>
                            </ng-template>
                          </kendo-tabstrip-tab>
                        }
                        @for (tab of _dataTabs; track tab) {
                          <!-- Picures Tab -->
                          @if (tab.name == 'Pictures') {
                            <kendo-tabstrip-tab #picturesTab title="Pictures" [disabled]="!_tabEnabled" [selected]="_currentUser && !_currentUser.isEnterprise">
                              <ng-template kendoTabContent>
                                <div class="greytabtop">
                                  <img class="mobiletabIcon" (click)="_mobileMenuToggle()" [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                  @if (canAccess('files', 'create')) {
                                    <button
                                      [class.ViewModeHiddenElement]="_pageState == 1" kendoButton (click)="_openForm('files')" class="topRightButtonSecond">
                                      Add Picture
                                    </button>
                                  }
                                  <button [class.ViewModeHiddenElement]="_pageState == 1" kendoButton (click)="_selectImagesHandler($event)" class="topRightButton mr-2 k-button">
                                    Select from Library
                                  </button>
                                </div>
                                <div class="tabcontent tabWizGridInside">
                                  <asap-grid-layout [selectable]="false"
                                    [returnedSelectedKeys]="_selectedImagesKeys"
                                    [pagingEnabled]="false"
                                    [enableSiteSelection]="false"
                                    [data]="_stockItemFilesPics"
                                    [isData]="true"
                                    class="gridWithcontent">
                                    <ng-template pageListColumn name="Name" field="file.name" let-item>
                                      {{item.file?.name}}
                                    </ng-template>
                                    <ng-template pageListColumn name="Description" field="file.description" let-item>
                                      {{item.file?.description}}
                                    </ng-template>
                                    <ng-template pageListColumn name="Type" field="file.type" let-item>
                                      {{item.file?.type}}
                                    </ng-template>
                                    <ng-template pageListColumn name="Stream" let-item>
                                      <img src="{{_storagePath + item.file?.thumbnail}}"
                                        alt="{{ item.file?.name }}"
                                        title="{{ item.file?.name }}"
                                        width="50"
                                        appImagePopup />
                                      </ng-template>
                                      <ng-template pageListColumn name="CreatedOn" field="file.createdOn" let-item>
                                        {{$safeNavigationMigration(item.file?.createdOn) | date}}
                                      </ng-template>
                                      <ng-template pageListColumn name="Primary" field="categoryFilePrimary" let-item>
                                        <input kendoCheckBox
                                          type="checkbox"
                                          name="Primary"
                                          [ngModelOptions]="{standalone: true}"
                                          [(ngModel)]="item.categoryFilePrimary"
                                          (ngModelChange)="_setPrimaryPic(item)"
                                          [disabled]="_pageState == 1" />
                                        </ng-template>
                                        @if (_pageState != 1; as item) {
                                          <ng-template pageListColumn name="command" let-item>
                          <button style="border: 2px solid #e3e3e3 !important; border-radius: 20px !important; margin-left: 5px !important;
                              padding: 5px 10px !important; color: #4d4d4d !important; font-size: 12px;"
                                              class="picture-remove-button k-button k-grid-remove-command" (click)="_removePicHandler(item)">
                                              Remove
                                            </button>
                                          </ng-template>
                                        }
                                      </asap-grid-layout>
                                    </div>
                                    <div class="tabcontent">
                                      <fieldset class="contenttabstyle margin-top-10">
                                        <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                          [pageState]="_pageState"
                                          [accounts]="_selectedAccountIds"
                                          [formName]="'stock'"
                                          page="categories"
                                          [invalidSubmit]="_invalidSubmit"
                                          (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                          (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                          (customFieldsDeleteValue)="_removeCustomField($event)"
                                          (customFieldsStatus)="formStatus($event)"
                                          [_customFieldsValue]="_customFieldsValue">
                                        </asap-custom-fields-form>
                                        <div class="form-group special_style_formgroup">
                                          <button kendobutton class="addNewFieldButton k-button" (click)="_addNewField(tab.id)">
                                            <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" />
                                            <span>Add New Field</span>
                                          </button>
                                        </div>
                                      </fieldset>
                                    </div>
                                  </ng-template>
                                </kendo-tabstrip-tab>
                              }
                              <!-- Stock Item Quantity Tab -->
                              @if (_pageState == 1 && false) {
                                <kendo-tabstrip-tab #stockItemQuantityTab title="Stock Item Quantity" [disabled]="!_tabEnabled">
                                  <ng-template kendoTabContent>
                                    <div class="greytabtop menumobilecontainer">
                                      <img class="mobiletabIcon" (click)="_mobileMenuToggle()" [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                    </div>
                                    <div class="tabcontent tabWizGridInside" [class.ViewModeDisabledControl]="_pageState == 1">
                                    </div>
                                    <div class="tabcontent">
                                      <fieldset class="contenttabstyle margin-top-10">
                                        <asap-custom-fields-form [customFields]="_customFields[tab.id]" [pageState]="_pageState" (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)">
                                        </asap-custom-fields-form>
                                        <div class="form-group special_style_formgroup">
                                          <button kendobutton class="addNewFieldButton k-button" (click)="_addNewField(tab.id)">
                                            <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" />
                                            <span>Add New Field</span>
                                          </button>
                                        </div>
                                      </fieldset>
                                    </div>
                                  </ng-template>
                                </kendo-tabstrip-tab>
                              }
                              <!-- Receive per Category Tab -->
                              @if (_pageState == 1 && false) {
                                <kendo-tabstrip-tab #ReceivePerCategoryTab title="Receive per Category" [disabled]="!_tabEnabled">
                                  <ng-template kendoTabContent>
                                    <div class="greytabtop menumobilecontainer">
                                      <img class="mobiletabIcon" (click)="_mobileMenuToggle()" [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                    </div>
                                    <div class="tabcontent tabWizGridInside" [class.ViewModeDisabledControl]="_pageState == 1">
                                    </div>
                                  </ng-template>
                                </kendo-tabstrip-tab>
                              }
                              <!-- Issue per Category Tab -->
                              @if (_pageState == 1 && false) {
                                <kendo-tabstrip-tab #IssuePerCategoryTab title="Issue per Category" [disabled]="!_tabEnabled">
                                  <ng-template kendoTabContent>
                                    <div class="greytabtop menumobilecontainer">
                                      <img class="mobiletabIcon" (click)="_mobileMenuToggle()" [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                    </div>
                                    <div class="tabcontent tabWizGridInside" [class.ViewModeDisabledControl]="_pageState == 1">
                                    </div>
                                  </ng-template>
                                </kendo-tabstrip-tab>
                              }
                              <!-- Move per Category Tab -->
                              @if (_pageState == 1 && false) {
                                <kendo-tabstrip-tab #MovePerCategoryTab title="Move per Category" [disabled]="!_tabEnabled">
                                  <ng-template kendoTabContent>
                                    <div class="greytabtop menumobilecontainer">
                                      <img class="mobiletabIcon" (click)="_mobileMenuToggle()" [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                    </div>
                                    <div class="tabcontent tabWizGridInside" [class.ViewModeDisabledControl]="_pageState == 1">
                                    </div>
                                  </ng-template>
                                </kendo-tabstrip-tab>
                              }
                              <!-- CUSTOM TABS -->
                              @if (tab.isCustom) {
                                <kendo-tabstrip-tab [title]="tab.name" [disabled]="!_tabEnabled">
                                  <ng-template kendoTabContent>
                                    <div class="tabcontent">
                                      <fieldset class="contenttabstyle margin-top-10">
                                        <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                          [pageState]="_pageState"
                                          [accounts]="_selectedAccountIds"
                                          [formName]="'stock'"
                                          page="categories"
                                          [invalidSubmit]="_invalidSubmit"
                                          (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                          (customFieldsDeleteValue)="_removeCustomField($event)"
                                          (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                          (customFieldsStatus)="formStatus($event)"
                                          [_customFieldsValue]="_customFieldsValue">
                                        </asap-custom-fields-form>
                                        <div class="form-group special_style_formgroup">
                                          <button kendobutton class="addNewFieldButton k-button" (click)="_addNewField(tab.id)">
                                            <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" />
                                            <span>Add New Field</span>
                                          </button>
                                        </div>
                                        <div class="form-group special_style_formgroup">
                                          <button kendobutton class="addNewFieldButton k-button" (click)="_deactivateTab(tab.id, 'categories')">
                                            <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" />
                                            <span>Deactivate Tab</span>
                                          </button>
                                        </div>
                                      </fieldset>
                                    </div>
                                  </ng-template>
                                </kendo-tabstrip-tab>
                              }
                            }
                          </kendo-tabstrip>
                        </div>
                        <div class="col-4 col-lg-4 col-xl-4 responsive_style">
                          @if (!_currentUser.isEnterprise) {
                            <div class="borderedNotesContainer">
                              <note #note
                                [_pageState]="_pageState"
                                [_model]="_model"
                                [_page]="_page">
                              </note>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="row no_row_margin">
                        <div class="col-12">
                          <button kendobutton class="addNewtabButton k-button" (click)="_addNewTab()">
                            <img class="backimage" src="/assets/menu/enterprise/add-icon-green.svg" />
                            <span>Add New Tab</span>
                          </button>
                        </div>
                      </div>
                      <div class="row no_row_margin">
                        <div class="col-12">
                          <button kendobutton class="reorderTabButton k-button" (click)="_reorderingtabs()">
                            <img class="backimage" src="/assets/menu/enterprise/reorder-tabs-icon.svg" />
                            <span>reorder tabs</span>
                          </button>
                        </div>
                      </div>
                      <div class="row no_row_margin">
                        <div class="col-12">
                          <p class="tabsMap" [class.ViewModeHiddenElement]="_pageState != 4">
                            Notes:
                          </p>
                          <p class="tabsMap" [class.ViewModeHiddenElement]="_pageState != 4">
                            You can Drag and Drop Fields to reorder by clicking on this image
                            <img class="reorder_image" [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        @if (_invalidForm) {
                          <asap-forms-validation-summary [form]="_form" [page]="'categories'"
                            [customValidation]="_customValidation" [additionalErrors]="_additionalErrors">
                          </asap-forms-validation-summary>
                        }
                      </div>
                    </div>
                    @if (_showImagesGrid) {
                      <div class="k-overlay"></div>
                    }
                  </form>
                  @if (_isDialiogCategory) {
                    <asap-dialog-layout [data]="_dialogModel" [componentName]="_dialogComponentName"
                      (closeDialog)="_closeDialog($event)">
                    </asap-dialog-layout>
                  }
                  @if (_showImagesGrid) {
                    <kendo-window title="Add Image(s) to Category" (close)="_closeImagesWindow()" class="addFromLibrary">
                      <div class="greytabtop">
                        <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedImagesHandler($event)">
                          Select & Return
                        </button>
                      </div>
                      <asap-grid-layout [selectable]="true"
                        [pagingEnabled]="true"
                        [headerEnable]="true"
                        [headerTitle]="'Select Image'"
                        [entityName]="_entity"
                        [addNewFormEnabled]="false"
                        [orderEnable]="true"
                        [page]="_filesPageName"
                        [groupingEnabled]="true"
                        [deletedEnabled]="false"
                        [selectByField]="'id'"
                        [searchResult]="_imageSearchResult"
                        [selectedKeys]="_selectedImagesKeys"
                        [selectByFieldTitle]="'Select Image'"
                        [enableSiteSelection]="false"
                        [filteringEnable]="true"
                        [resolver]="_getAccountImages"
                        (onRowSelectionChanges)="_onImageRowSelectionChanges($event)"
                        (onRowObjectSelectionChanges)="_onImageObjectRowSelectionChanges($event)">
                        @for (column of _gridColumns; track column) {
                          @if (column.selected) {
                            @if (!column.isTemplate) {
                              <ng-template pageListColumn
                                [field]="column.field"
                                [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                [type]="column.type"
                                let-item>
                                @if (column.type == 'date') {
                                  {{ item[column.field] | dateFormat }}
                                }
                                @if (column.type != 'date' && column.field != 'thumbnail') {
                                  {{column.field | complexFieldValue: item}}
                                }
                                @if (column.field == 'thumbnail') {
                                  <img src="{{_storagePath + column.field | complexFieldValue: item}}"
                                    alt="{{ item.name }}"
                                    title="{{ item.name }}"
                                    width="50" />
                                  }
                                </ng-template>
                              }
                              @if (column.isTemplate) {
                                <ng-template pageListColumn
                                  [field]="column.field"
                                  [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                  [type]="column.type"
                                  let-item>
                                  @if (column.type == 'date') {
                                    {{ item[column.field] | dateFormat }}
                                  }
                                  @if (column.type != 'date' && column.field != 'thumbnail') {
                                    {{column.field | complexFieldValue: item}}
                                  }
                                  @if (column.field == 'thumbnail') {
                                    <img src="{{_storagePath + item.thumbnail}}" alt="{{ item.name }}" title="{{ item.name }}" width="50" />
                                  }
                                </ng-template>
                              }
                            }
                          }
                        </asap-grid-layout>
                      </kendo-window>
                    }
                    @if (CheckIfWeAreInEditMode()) {
                      <div class="asap-footer">
                        <ul class="asap-footer-content-list">
                          <li>
                            <span class="label-footer">Date Added:</span>{{ _model.createdOn | dateFormat }}<span class="separator">.</span>
                            <span class="label-footer">Added By User:</span>{{ _model.createdUser? _model.createdUser.userName : null }}
                          </li>
                          <li>
                            <span class="label-footer">Last Edited:</span>{{ _model.lastUpdatedOn | dateFormat }}<span class="separator">.</span>
                            <span class="label-footer">Last Edited By User:</span>{{_model.updatedUser? _model.updatedUser.userName : null}}
                          </li>
                        </ul>
                      </div>
                    }
                    @if (_isEditForms || _deactivatedFormTabsForm) {
                      <div class="k-overlay"></div>
                    }
                  </kendo-window>
                }
                @if (_showCirclesForm) {
                  <kendo-window title="Category Per Account" (keydown.enter)="$event.preventDefault()"
                    (close)="_closeCirclesForm()" class="singleDonutPopup">
                  </kendo-window>
                }
                @if (_editFormActive) {
                  <kendo-window
                    title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                    (close)="_closeCustomFields()"
                    class="customFieldsWindow">
                    <asap-custom-fields [accounts]="_selectedAccountIds"
                      [tabGroup]="_selectedTabId"
                      [labelId]="_selectedLabelId"
                      [labelObjectCode]="_selectedLabelObjectCode"
                      [formName]="'stock'"
                      page="categories"
                      [isCustomfieldsForm]="_isCustomfieldsFormValue"
                      [isCustomtabsForm]="_isAddTabFormValue"
                      [isRenameForm]="_isRenameFormValue"
                      [language]="_language"
                      [isRenameCustomForm]="_isRenameCustomFormValue"
                      [isRenameLabel]="_isRenameLabel"
                      [isMandatory]="_isMandatory"
                      (closePopup)="ClosePopup($event)"
                      [permissionScope]="_permissionScope">
                    </asap-custom-fields>
                  </kendo-window>
                }
                @if (_orderingTabsForm) {
                  <kendo-window title="Tab Reordering" (keydown.enter)="$event.preventDefault()" (close)="_closeOrderingTabsForm()">
                    <div class="row no_row_margin py-2 margin-top-4 border_sections">
                      <div class="col-12">
                        <button kendoButton class="steps_buttons_class" (click)="_onSaveTabOrdering()">
                          <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                          <span>save & Close</span>
                        </button>
                      </div>
                    </div>
                    <div class="row no_row_margin p-3 margin-top-30">
                      @if (false) {
                        <div class="col-12 margin-top-10">
                          <div class="form-group">
                            <label for="itemType" class="control-label">Tab 1</label>
                            <kendo-combobox [data]="_dataTabsSelected" [suggest]="true" [textField]="'name'"
                              [valueField]="'name'" placeholder="Accounts/Sites" class="newFormControlWidth disabled">
                            </kendo-combobox>
                          </div>
                        </div>
                      }
                      @for (item of _dataTabs ; track item; let i = $index) {
                        <div class="col-12 margin-top-10">
                          <div class="form-group">
                            <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                            <kendo-combobox [data]="_dataTabsSelected"
                              [suggest]="true"
                              [textField]="'name'"
                              [valueField]="'name'"
                              [placeholder]="item.name"
                              required
                              class="bordered newFormControlWidth"
                              (valueChange)="_comboValueChange($event,i)">
                            </kendo-combobox>
                          </div>
                        </div>
                      }
                    </div>
                  </kendo-window>
                }
                @if (_deactivatedFieldsForm) {
                  <kendo-window title="Deactivated Fields" (close)="_closeInactiveFields()">
                    <div class="row no_row_margin margin-top-30">
                      <div class="col-12 margin-top-10">
                        <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                          <kendo-grid-column field="name" title="Fields Name">
                          </kendo-grid-column>
                          <kendo-grid-column field="formTab.name" title="Tab Name">
                          </kendo-grid-column>
                          <kendo-grid-column field="createdOn" title="Added Date" type="date">
                            <ng-template kendoGridCellTemplate let-dataItem>
                              {{dataItem.createdOn | dateFormat}}
                            </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column field="lastUpdatedOn" title="Deactivation Date" type="date">
                            <ng-template kendoGridCellTemplate let-dataItem>
                              {{dataItem.lastUpdatedOn | dateFormat}}
                            </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column field="Command" title="Command">
                            <ng-template kendoGridCellTemplate let-dataItem>
                              <div class="action-button action-button-deactivate" (click)="_reactivate(dataItem)">
                                <div class="action-button-icon">
                                  <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                </div>
                                <div class="edit-icon-text">Reactivate</div>
                              </div>
                            </ng-template>
                          </kendo-grid-column>
                        </kendo-grid>
                      </div>
                    </div>
                  </kendo-window>
                }
                @if (_SIQChartForm) {
                  <kendo-window title="Receieved stock item per category" (keydown.enter)="$event.preventDefault()" (close)="_closeSIQChartForm()" class="fullWidthFormForm">
                    <div class="col-12">
                      <div class="asap-section-container zero-padding">
                        <div class="row zeromarginRow">
                          <div class="col-12 zeroPaddingColumn">
                            <div class="header-section-gray">
                              Receieved stock item per category - Graph
                              <span [ngClass]="isStockItemChartExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                class="float-right pointer-click mt-2 mr-2" (click)="ExpandCollapseStockItemChart(isStockItemChartExpanded)">
                              </span>
                            </div>
                          </div>
                        </div>
                        @if (isStockItemChartExpanded) {
                          <div class="graph-container-display">
                            <div id="chart-line">
                              <apx-chart [series]="stockItemQuantityChart.series"
                                [chart]="stockItemQuantityChart.chart"
                                [xaxis]="stockItemQuantityChart.xaxis"
                                [dataLabels]="stockItemQuantityChart.dataLabels"
                              [stroke]="stockItemQuantityChart.stroke"></apx-chart>
                            </div>
                            <div>
                              <apx-chart [series]="stockItemQuantitySecondChart.series" [chart]="stockItemQuantitySecondChart.chart" [xaxis]="stockItemQuantitySecondChart.xaxis">
                              </apx-chart>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="asap-section-container zero-padding">
                        <div class="row zeromarginRow">
                          <div class="col-12 zeroPaddingColumn">
                            <div class="header-section-gray">
                              Receieved stock item per category - Grid
                              <span [ngClass]="isStockItemGridExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                class="float-right pointer-click mt-2 mr-2"
                              (click)="ExpandCollapseStockItemGrid(isStockItemGridExpanded)"></span>
                            </div>
                          </div>
                          @if (isStockItemGridExpanded) {
                            <div class="col-12 zeroPaddingColumn">
                              <div class="col-12 mt-1 mb-2 chart-category-code-description">
                                <span>Category code {{_model.code}}</span>
                              </div>
                              @if (_receiveGridColumns) {
                                <asap-grid-layout
                                  [page]="'purchaseOrders'"
                                  [pagingEnabled]="false"
                                  [sortingEnabled]="true"
                                  [filteringEnable]="true"
                                  [headerEnable]="true"
                                  [importEnable]="true"
                                  [exportExcelEnable]="true"
                                  [exportPDFEnable]="true"
                                  [orderEnable]="true"
                                  [headerTitle]="'Purchase Orders'"
                                  [enableSiteSelection]="false"
                                  [resolver]="_getReceivedStockItemQuantity"
                                  class="ListGrid"
                                  [refreshInitData]="true"
                                  [withHeader]="false">
                                  @for (column of _receiveGridColumns; track column) {
                                    @if (column.selected) {
                                      @if (column.isTemplate) {
                                        <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type" let-item>
                                          @if (column.field == 'stockItem.number') {
                                            {{item.stockItem?.number}}
                                          }
                                          @if (column.field == 'stockItem.description') {
                                            {{item.stockItem?.description}}
                                          }
                                          @if (column.field == 'stockItem.itemType.name') {
                                            {{item.stockItem?.itemType?.name}}
                                          }
                                          @if (column.field == 'stockItem.itemType.description') {
                                            {{item.stockItem?.itemType?.description}}
                                          }
                                          @if (column.field == 'location.code') {
                                            {{item.location?.code}}
                                          }
                                          @if (column.field == 'location.description') {
                                            {{item.location?.description}}
                                          }
                                          @if (column.field == 'stockReceive.vendor.code') {
                                            {{item.stockReceive?.vendor?.code}}
                                          }
                                          @if (column.field == 'stockReceive.vendor.name') {
                                            {{item.stockReceive?.vendor?.name}}
                                          }
                                          @if (column.field == 'stockLocation.expirationDate') {
                                            {{ $safeNavigationMigration(item.stockLocation?.expirationDate) | dateFormat }}
                                          }
                                          @if (column.field == 'stockLocation.udField3') {
                                            {{item.stockLocation?.udField1}}
                                          }
                                          @if (column.field == 'stockLocation.udField3') {
                                            {{item.stockLocation?.udField2}}
                                          }
                                          @if (column.field == 'stockLocation.udField3') {
                                            {{item.stockLocation?.udField3}}
                                          }
                                          @if (column.field == 'stockLocation.udFieldDate1') {
                                            {{ $safeNavigationMigration(item.stockLocation?.udFieldDate1) | dateFormat }}
                                          }
                                          @if (column.field == 'stockLocation.udFieldDate2') {
                                            {{ $safeNavigationMigration(item.stockLocation?.udFieldDate2) | dateFormat }}
                                          }
                                          @if (column.field == 'stockLocation.udFieldDate3') {
                                            {{ $safeNavigationMigration(item.stockLocation?.udFieldDate3) | dateFormat }}
                                          }
                                          @if (column.field == 'stockPurchaseOrder.vendor.code') {
                                            {{item.stockPurchaseOrder?.vendor.code}}
                                          }
                                          @if (column.field == 'stockPurchaseOrder.vendor.name') {
                                            {{item.stockPurchaseOrder?.vendor.name}}
                                          }
                                          @if (column.field == 'user.username') {
                                            {{item.user?.username}}
                                          }
                                          @if (column.field == 'stockItem.description') {
                                            {{item.stockItem?.description}}
                                          }
                                          @if (column.field == 'stockItem.costInfo.cost') {
                                            {{$safeNavigationMigration(item.stockItem?.costInfo?.cost) | costFormat}}
                                          }
                                          @if (column.field == 'stockItem.costInfo.code') {
                                            {{item.stockItem?.costInfo?.code}}
                                          }
                                          @if (column.field == 'stockPurchaseOrder.orderDate') {
                                            {{item.stockPurchaseOrder?.orderDate}}
                                          }
                                          @if (column.field == 'stockItem.category.code') {
                                            {{item.stockItem?.category?.code}}
                                          }
                                          @if (column.field == 'stockItem.category.description') {
                                            {{item.stockItem?.category?.description}}
                                          }
                                          @if (column.field == 'stockItem.inventoryUnitOfMeasure.code') {
                                            {{item.stockItem?.inventoryUnitOfMeasure?.code}}
                                          }
                                          @if (column.field == 'stockItem.receiveUnitOfMeasure.code') {
                                            {{item.stockItem?.receiveUnitOfMeasure?.code}}
                                          }
                                          @if (column.field == 'stockItem.generalDescription') {
                                            {{item.stockItem?.generalDescription}}
                                          }
                                          @if (column.field == 'location.site.id') {
                                            {{item.location?.site?.id}}
                                          }
                                          @if (column.field == 'location.site.name') {
                                            {{item.location?.site?.name}}
                                          }
                                          @if (column.field == 'stockItem.costInfo.extendedCost') {
                                            {{ (($safeNavigationMigration(item.stockItem?.costInfo?.cost) / $safeNavigationMigration(item.stockItem?.receiveUnitOfMeasure?.multiplier)) * $safeNavigationMigration(item.stockItem?.inventoryUnitOfMeasure?.multiplier) * item.quantityReceived) | costFormat }}
                                          }
                                          @if (column.field == 'stockItem.costInfo.inventoryCost') {
                                            {{ (($safeNavigationMigration(item.stockItem?.costInfo?.cost) / $safeNavigationMigration(item.stockItem?.receiveUnitOfMeasure?.multiplier)) * $safeNavigationMigration(item.stockItem?.inventoryUnitOfMeasure?.multiplier)) |  costFormat }}
                                          }
                                        </ng-template>
                                      }
                                      @if (!column.isTemplate) {
                                        <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type" let-item>
                                          @if (column.type == 'date') {
                                            {{ item[column.field] | dateFormat }}
                                          }
                                          @if (column.type != 'date' && column.field != 'id') {
                                            {{item[column.field]}}
                                          }
                                          @if (column.field == 'id') {
                                            {{item.stockReceiveId}}
                                          }
                                        </ng-template>
                                      }
                                    }
                                  }
                                </asap-grid-layout>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="col-12 margin-top-10">
                      <button kendoButton class="steps_buttons_class" (click)="_closeSIQChartForm()">
                        <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                        <span>close</span>
                      </button>
                    </div>
                  </kendo-window>
                }
                @if (_isEditForms) {
                  <asap-edit-forms
                    (close)="_onCloseEditForms($event)"
                    (saved)="_closeCustomFields()"
                    [page]="_page"
                    [permissionScope]="_permissionScope">
                  </asap-edit-forms>
                }
                @if ( _isDialiogCategory || _editFormActive || _showCirclesForm || _orderingTabsForm || _deactivatedFieldsForm || _isEditForms) {
                  <div class="k-overlay"
                  ></div>
                }
                @if (_deactivatedFormTabsForm) {
                  <kendo-window
                    title="Deactivated Forms"
                    (close)="_closeInactiveFormTabs()"
                    style="z-index: 10050;">
                    <div class="row no_row_margin margin-top-30">
                      <div class="col-12 margin-top-10">
                        <kendo-grid [data]="_deactivatedFormTabsGridData" [scrollable]="'none'">
                          <!-- <kendo-grid-column field="name" title="Fields Name">
                        </kendo-grid-column> -->
                        <kendo-grid-column field="name" title="Tab Name">
                        </kendo-grid-column>
                        <kendo-grid-column field="createdOn" title="Added Date" type="date">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.createdOn | dateFormat}}
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="lastUpdatedOn"
                          title="Deactivation Date"
                          type="date">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.lastUpdatedOn | dateFormat}}
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="Command" title="Command">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <div class="action-button action-button-deactivate"
                              (click)="_reactivateFormTab(dataItem)">
                              <div class="action-button-icon">
                                <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                              </div>
                              <div class="edit-icon-text">Reactivate</div>
                            </div>
                          </ng-template>
                        </kendo-grid-column>
                      </kendo-grid>
                    </div>
                  </div>
                </kendo-window>
              }
